export default __webpack_public_path__ + "static/media/fundo.d117ae0e.svg";